import { ApiResponse } from "../../../types";
import {postRequestWithAuth, Tparams } from "../configuration";
import getApiWithVersion from "../apis";
import { API_VERSION } from "../../constants/common";

export enum UserActivityType {
  user = 'User',
  location = 'Location',
  order = 'Order'
}
const api = getApiWithVersion(API_VERSION.V1);
export interface Activity{
    userActivity(payload:any,params:Tparams,activityType:UserActivityType,query:Record<string, any>):Promise<ApiResponse<boolean>>;
    
}

// const resp = API.API_V1.activity.user(payload, params, activityType.priceFetch, {})
const activity: Activity = {
    userActivity(data, params, activityType, query) {
        const q = query
        return postRequestWithAuth(api.USER_LOG, data, params, q)
    // }
        // else if(!params)
        //     return postRequestWithAuth(api.VERIFY_OTP, data, undefined, q)
        
    },

   
}

export default activity;

